import {
	request, publicRequest, userAuth
} from '@/core';
import moment from 'moment-timezone';

let setUserInfo = async function({ commit }, payload) {
	if (payload) {
		commit('setLoggedIn', true);
		commit('setUser', payload);
	} else {
		commit('setLoggedIn', false);
		commit('clearUser');
	}
};

let userHasRequestedAccess = async function() {
	return new Promise(resolve => {
		request({
			method: 'get',
			url: '/users/currentUser/hasRequestedAccess',
		}).then(response => {
			resolve(response);
		});
	});
};

let fetchUsersWithAccess = async function({ commit }) {
	let users = await request({
		method: 'get',
		url: '/users'
	});
	commit('setUsersWithAccess', users);
};

let upgradeUser = async function({ commit }, payload) {
	let userId = payload;
	await request({
		method: 'post',
		url: `/users/${userId}/upgrade`,
	});
	commit('movetoSuperusers', payload);
};

let downgradeUser = async function({ commit }, payload) {
	let userId = payload;
	await request({
		method: 'post',
		url: `/users/${userId}/downgrade`,
	});
	commit('movefromSuperusers', payload);
};

let deleteUsers = async function({ }, payload) {
	if (payload.length > 1) {
		await request({
			method: 'delete',
			url: '/users',
			data: payload
		});
	} else {
		let [userId] = payload;
		await request({
			method: 'delete',
			url: `/users/${userId}`,
		});
	}
};

let clearUserStore = function({ commit }) {
	commit('setLoggedIn', false);
	commit('setIsVerified', false);
	commit('setHasAccess', false);
	commit('setIsSuper', false);
	commit('setTransporterCode', null);
	commit('setCompanies', []);
	commit('setUsersWithAccess', []);
	commit('clearTransporterCode');
};

let fetchCompanies = async function({ commit }) {
	let companies = await publicRequest({
		method: 'get',
		url: '/companies'
	});
	commit('setCompanies', companies);
};

let createUserWithFirebase = async function(context, payload) {
	let userData = payload;
	let result = await request({
		method: 'post',
		url: '/users/createUser',
		data: userData
	});
	return result;
};

let userLastLogin = async function({ commit }) {
	try {
		// eslint-disable-next-line
		var { lastLogin } = await userAuth.userLastLogin();
	} catch (e) {
		//User not logged in
		return;
	}
	let newDateObj = {
		date: null,
		hasTime: true,
		timeZone: 'Europe/Oslo',
		epoch: null
	};
	if (!lastLogin) {
		commit('setLastLogin', newDateObj);
		userAuth.updateLastLogin();
		return;
	}
	let newDate = moment(lastLogin);
	let dateString = newDate.format('YYYYMMDDHHmm');
	newDateObj.date = parseInt(dateString, 10);
	commit('setLastLogin', newDateObj);
	userAuth.updateLastLogin();
};

function setCompany({ commit }, transporterCode) {
	commit('setHasAccess', false);
	commit('setIsSuper', false);
	commit('setTransporterCode', transporterCode);
}

export default {
	setUserInfo,
	userHasRequestedAccess,
	fetchUsersWithAccess,
	upgradeUser,
	downgradeUser,
	deleteUsers,
	clearUserStore,
	fetchCompanies,
	createUserWithFirebase,
	userLastLogin,
	setCompany
};